import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useAIMessageStyles = makeStyles({
  footer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: tokens.spacingVerticalXS,
  },
  footerContent: {
    display: 'flex',
    columnGap: tokens.spacingHorizontalS,
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative',
    minHeight: tokens.spacingVerticalXXL,
  },
  buttons: {
    display: 'flex',
    position: 'absolute',
    top: 0,
  },
  dataDisclaimerContainer: {
    width: 'max-content',
    flexGrow: 1,
  },
  dataDisclaimerButton: {
    paddingLeft: tokens.spacingHorizontalNone,
    paddingTop: tokens.spacingHorizontalNone,
    paddingBottom: tokens.spacingHorizontalNone,
    paddingRight: tokens.spacingHorizontalNone,
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralStrokeAccessible,
    '&:hover':{
      color: tokens.colorNeutralStrokeAccessible,
    },
    '&:active':{
      color: `${tokens.colorNeutralStrokeAccessible} !important`,
    },
    '&:focus':{
      color: tokens.colorNeutralStrokeAccessible,
    },
    '& span':{
      marginLeft: tokens.spacingHorizontalNone,
      marginTop: tokens.spacingHorizontalXS,
    }
  },
  infoIcon:{
    color: tokens.colorNeutralStrokeAccessible,
    marginLeft: `${tokens.spacingHorizontalNone} !important`,
  },
  referenceGroup: {
    '& .fai-ReferenceGroup__label': {
      fontSize: tokens.fontSizeBase100,
    },
  },
  reference: {
    cursor: 'pointer',
    columnGap: 'unset',
    gridTemplateColumns: '0px 0px 1fr min-content',
    '& .fai-Reference__label': {
      wordBreak: 'break-all',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      ...shorthands.overflow('hidden'),
    },
  },
});
